interface EnvConfig {
  API_URL: string
  AUTH_URL: string
  AUTH_FRONT_URL: string
  AUTH_CLIENT_ID: string
  SSE_URL: string
}

declare global {
  interface Window {
    __env?: Partial<EnvConfig>
  }
}

function env(key: keyof EnvConfig, fallback = ''): string {
  return window.__env?.[key] ?? fallback
}

export const config = {
  apiUrl: env('API_URL'),
  authUrl: env('AUTH_URL'),
  authFrontUrl: env('AUTH_FRONT_URL'),
  authClientId: env('AUTH_CLIENT_ID'),
  sseUrl: env('SSE_URL'),
}
